import React, { FunctionComponent, useEffect } from 'react';
import {
  AppPages,
  currentPage,
  useQuery,
} from '../../../common/routing/app-navigator';
import { useAuth0 } from '@auth0/auth0-react';
import { setLastLoggedInOrg } from '../../../organizations/utils/local-storage-utils';
import { Organization } from '../../../organizations/organization-types';
import AppSpinner from '../../../common/components/AppSpinner';
import backgroundImage from '../../../assets/images/onboarding-background.jpg';
import { Backdrop } from '@mui/material';
const OrgLoginPage: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const { loginWithRedirect } = useAuth0();

  // ?invitation=q04azkaXFQiXu48bg8aQAsbTtFWASxhW&organization=org_g6YFfmBCyAUdytHI&organizationName=testlogin
  const query = useQuery();
  const organizationID = query.get('organization');
  const invitationID = query.get('invitation');
  const orgName = query.get('organization_name');
  const displayName = query.get('display_name');
  const currPage = currentPage();

  useEffect(() => {
    if (!organizationID || !invitationID || !orgName) {
      loginWithRedirect();
      return;
    }

    const organization: Organization = {
      branding: null,
      name: orgName,
      id: organizationID,
      display_name: displayName || '',
    };

    setLastLoggedInOrg(organization);

    loginWithRedirect({
      organization: organizationID,
      invitation: invitationID,
      appState: {
        returnTo: AppPages.Home,
      },
    });
  }, [loginWithRedirect, organizationID, invitationID, orgName, displayName]);

  return (
    <Backdrop
      open
      style={{
        position: 'fixed',
        backgroundImage: `url("${backgroundImage}")`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundColor: '#cccccc',
      }}>
      <AppSpinner
        text={`Redirecting to ${
          currPage === AppPages.OrgLogin ? 'login' : 'sign up'
        } page...`}
      />
    </Backdrop>
  );
};

export default OrgLoginPage;
